import { makeStyles } from '@material-ui/core';
import colors from './colors';
import themeStyle from './theme';

const contentStyles = makeStyles({
  label: {
    ...themeStyle.typography.smMedium,
    color: colors.gray[700]
  },
  textField: {
    padding: '10px 14px',
    marginTop: 6,
    marginBottom: 0,
    border: `1px solid ${colors.gray[300]}`,
    borderRadius: 8,
    background: colors.base.white
  },
  required: {
    marginLeft: 2,
    color: colors.error[700]
  },
  helperText: {
    position: 'relative',
    fontSize: 14,
    fontWeight: 400,
    color: colors.gray[700]
  },
  error: {
    color: colors.error[700]
  },
  input: {
    color: colors.gray[900],
    '& .Mui-disabled': {
      color: colors.gray[900]
    }
  },
  disabledInput: {
    '& .Mui-disabled': {
      color: colors.gray[400]
    }
  }
});

export default contentStyles;
